import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ShoppingCart, RefreshCw, Menu, X, Home, Gift, MessageSquare, LogOut, Package, User } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useCart } from '../context/CartContext';
import { PWAInstallHeaderPill } from './PWAInstallHeaderPill';

const MENU = [
  { to: '/customer', label: 'Home', icon: Home, id: 'dashboard' },
  { to: '/customer/orders', label: 'Orders', icon: Package, id: 'orders' },
  { to: '/customer/refer', label: 'Rewards', icon: Gift, id: 'rewards' },
  { to: '/customer/profile', label: 'Profile', icon: User, id: 'profile' },
  { to: '/contact', label: 'Contact dispatch', icon: MessageSquare, id: 'contact' },
];

const iconBtn = 'p-2 rounded-full transition-colors hover:bg-[var(--am-inset)]';

export function ModernNavbar() {
  const { logout } = useAuth();
  const { cartCount } = useCart();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [refreshing, setRefreshing] = useState(false);

  const refresh = () => {
    if (refreshing) return;
    setRefreshing(true);
    setTimeout(() => window.location.reload(), 250);
  };
  const doLogout = async () => { setOpen(false); await logout(); navigate('/login'); };

  return (
    <nav
      className="sticky top-0 z-50 backdrop-blur-md border-b"
      style={{ paddingTop: 'env(safe-area-inset-top)', background: 'rgba(247,245,240,0.88)', borderColor: 'var(--am-hair)', fontFamily: 'var(--am-font-sans)' }}
      data-testid="modern-navbar"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/customer" className="text-lg font-semibold tracking-tight" style={{ color: 'var(--am-emerald-800)' }} data-testid="nav-logo">
          Ash <span style={{ color: 'var(--am-gold-500)' }}>&amp;</span> Merch
        </Link>
        <div className="flex items-center gap-1" style={{ color: 'var(--am-ink-2)' }}>
          <PWAInstallHeaderPill inline />
          <button onClick={refresh} className={iconBtn} aria-label="Refresh" data-testid="nav-refresh-mobile">
            <RefreshCw className={`w-5 h-5 ${refreshing ? 'animate-spin' : ''}`} />
          </button>
          <Link to="/customer/cart" className={`relative ${iconBtn}`} aria-label="Cart" data-testid="nav-cart-mobile">
            <ShoppingCart className="w-5 h-5" />
            {cartCount > 0 && (
              <span className="absolute -top-0.5 -right-0.5 text-[10px] font-bold min-w-[18px] h-[18px] px-1 flex items-center justify-center rounded-full text-white" style={{ background: 'var(--am-emerald-600)' }} data-testid="nav-cart-count">
                {cartCount}
              </span>
            )}
          </Link>
          <button onClick={() => setOpen((o) => !o)} className={iconBtn} aria-label="Open menu" data-testid="nav-mobile-toggle">
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>
      {open && (
        <div className="absolute right-4 top-full mt-2 w-56 rounded-[14px] border p-2 am-drawer-enter" style={{ background: 'var(--am-card)', borderColor: 'var(--am-hair)', boxShadow: 'var(--am-shadow-3)' }} data-testid="modern-nav-menu">
          {MENU.map(({ to, label, icon: Icon, id }) => (
            <Link key={id} to={to} onClick={() => setOpen(false)} className="flex items-center gap-3 px-3 py-2.5 rounded-[10px] text-sm hover:bg-[var(--am-inset)] transition-colors" style={{ color: 'var(--am-ink-1)' }} data-testid={`nav-mobile-${id}`}>
              <Icon className="w-4 h-4" style={{ color: 'var(--am-emerald-600)' }} />{label}
            </Link>
          ))}
          <button onClick={doLogout} className="w-full flex items-center gap-3 px-3 py-2.5 rounded-[10px] text-sm hover:bg-red-50 transition-colors text-red-600" data-testid="nav-mobile-logout">
            <LogOut className="w-4 h-4" />Log out
          </button>
        </div>
      )}
    </nav>
  );
}
